import { render } from "./Urgent.vue?vue&type=template&id=b70c2fa6"
import script from "./Urgent.vue?vue&type=script&lang=js"
export * from "./Urgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__